<template>
    <VeeForm :validation-schema="postcodeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12">
        <form class="postcode-form" @submit="handleSubmit($event, $emit('submit'))" method="post" :action="this.baseUrl + '/rechoose-fitters'">
            <div class="row d-flex align-items-center mb-3">
                <div class="col-12 col-md-5">
                    <b class="d-inline-block text-navy">Showing local fitters in the area of</b>
                    <div class="row gx-3 gy-2 w-100">
                        <div class="col-4">
                            <ErrorMessage name="postcode">
                                <span class="error"></span>
                            </ErrorMessage>
                            <Popper :content="errors.postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.postcode ? true : false">
                                <Field id="postcode" name="postcode" type="text" class="form-control postcode uppercase" :value="filters.postcode" @input="updateFilters('postcode', $event.target.value)" placeholder="Enter postcode"/>
                            </Popper>
                        </div>
                        <div class="col-5">
                            <ErrorMessage name="distance" class="error"/>
                            <Field name="distance" as="select" class="form-select" id="distance-input" :value="filters.distance" @input="updateFilters('distance', $event.target.value)">
                                <option v-for="mile, key in [5, 10, 15, 25, 50]" :value="mile" :key="key">{{ mile }} Miles</option>
                            </Field>
                        </div>
                        <div class="col-3">
                            <button type="submit" class="btn btn-sm btn-primary">
                                Go
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 mt-2 mt-sm-0 mb-2 mb-md-0" v-if="postcode != ''">
                    <b class="d-inline-block text-navy">Sort fitters by:</b>
                    <Field name="sort_by" as="select" class="form-select" id="sortby-input" :value="filters.sortBy" @input="updateFilters('sortBy', $event.target.value)">
                        <option value="distance" :selected="filters.sortBy != null && filters.sortBy == 'distance'">Nearest first</option>
                        <option v-if="hasReviews" value="average_score" :selected="filters.sortBy != null && filters.sortBy == 'average_score'">Best rating</option>
                    </Field>
                    <ErrorMessage name="sort_by" class="error"/>
                </div>
                <div class="col-12 col-md-4" v-if="postcode != ''">
                    <b class="d-block mb-1 text-navy">Show Fitters:</b>
                    <div class="d-inline-block me-3" v-for="(type, key) of fitterTypes" :key="key">
                        <input name="fitter_types[]" type="checkbox" class="btn-check" :id="type" :checked="typeIsIncluded(type)" @input="updateFitterTypes(type, $event.target.checked)" autocomplete="off">
                        <label class="capitalize btn cursor-pointer d-md-block d-lg-inline-block mb-md-2 mb-lg-0" :class="[typeIsIncluded(type) ? 'btn-secondary' : 'btn-light']" :for="type" :key="key">
                            {{ type }} fitter
                        </label>
                    </div>
                </div>
            </div>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';
    
    export default {
        props:  ['filters', 'hasReviews', 'page', 'fittersShown', 'postcode'],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const postcodeValidationSchema = yup.object({
                'postcode': yup.string().required('postcode is a required field')
            });

            return {
                fitterTypes: ['garage', 'mobile'],
                postcodeValidationSchema,
                selectedFitterTypes: []
            }
        },
        created() {
            
        },
        mounted() {
        },
        methods: {
            typeIsIncluded(type) {
                return this.filters.fitterTypes.includes(type);
            },
            updateFitterTypes(type, checked) {
                // Clone fitter types so we don't edit the original prop
                let fitterTypes = [...this.filters.fitterTypes];

                // Check if type is already present in fitter types
                const index = fitterTypes.indexOf(type);

                if (checked && index === -1) fitterTypes.push(type);

                if (!checked && index > -1) fitterTypes.splice(index, 1);

                this.updateFilters('fitterTypes', fitterTypes);
            },
            updateFilters(key, value) {
                this.$emit('update-filters', {
                    key: key,
                    value: value
                });
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .btn-grey {
        color: #141414;
        background-color: #D3D3D3;
        cursor: pointer;
    }
</style>